var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 88,
    viewBox: "0 0 76 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1922 80.9998C47.1922 80.9998 47.5439 69.0437 47.1922 64.4722C46.8406 59.9008 46.4889 44.5454 46.3717 43.6076C46.2545 42.6699 46.1373 41.0289 45.434 39.0362C44.7307 37.0435 42.9724 33.1753 43.0896 27.7833C43.2068 22.3914 42.8439 22.6258 43.084 20.7503C43.3241 18.8749 43.6757 18.406 44.4962 16.8822C45.3167 15.3584 47.5439 14.069 48.4816 13.6001C49.4193 13.1312 50.8259 13.2485 51.5292 14.3034C52.2325 15.3584 53.4047 19.9298 53.8736 22.0397C54.3425 24.1496 54.8113 28.9555 57.859 28.6039C60.9066 28.2522 59.5 23.9152 59.1483 22.6258C58.7967 21.3364 57.3901 13.014 57.2729 10.5525C57.1557 8.09091 54.3425 8.20813 53.2875 8.677C52.2325 9.14586 51.0857 9.4872 51.8481 14.9373",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 17.7612C46.6641 17.7612 46.7813 18.6408 47.719 19.9884C47.9928 20.3822 48.2713 20.8604 48.5377 21.3612C49.1838 22.5756 49.7558 23.9203 50.0043 24.5007C50.3559 25.3213 51.83 28.0088 53.8134 27.9C55.7976 27.7912 55.0746 26.6556 55.0746 26.6556",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0234 21.0432C45.0234 21.0432 46.6063 21.3358 48.1302 21.3358",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7822 9.19487C56.7822 9.19487 56.6865 3.98856 57.2726 2.93361C57.8587 1.87866 58.6201 1 60.2612 1C61.9022 1 63.4851 1.35165 63.8367 3.52063C64.1884 5.68961 64.3637 8.67817 64.3637 8.67817L64.9498 17.235C64.9498 17.235 65.1261 19.2868 67.5286 19.2868C69.932 19.2868 70.1665 16.708 70.2246 15.1251C70.2837 13.5422 70.6935 8.40904 70.6935 8.40904C70.6935 8.40904 71.0451 5.92405 69.2869 4.45837C67.5286 2.99269 64.3637 3.69693 64.1593 6.1191",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9181 16.7596C64.9181 16.7596 64.9509 19.4031 62.4303 19.2859C59.9097 19.1686 59.3827 17.176 59.1482 15.3005C58.9138 13.425 58.8547 11.3151 58.8547 11.3151C58.8547 11.3151 58.2105 8.20933 57.917 6.68457",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3018 21.3367C65.3018 21.3367 67.588 23.5638 69.9904 23.8573",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3262 13.365C70.3262 13.365 73.4488 19.4612 74.3275 22.597C75.2071 25.7328 75.3243 26.3836 73.5661 27.9046C71.8078 29.4256 69.0527 33.8798 68.5839 34.5831C68.115 35.2864 66.4158 37.3963 65.3018 38.6266C64.1887 39.8569 64.3641 43.7842 64.3641 45.7769C64.3641 47.7696 64.892 62.8324 65.419 65.0586C65.947 67.2857 67.2364 78.3632 68.1741 80.2386",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.543 75H30.6836L19.2773 56.2891V75H13.418V46.5625H19.2773L30.7031 65.3125V46.5625H36.543V75Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 63.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhand);
export default __webpack_public_path__ + "static/media/Nhand.ecc290b62d5e881d7cd78bc13408ed02.svg";
export { ForwardRef as ReactComponent };